import { render, staticRenderFns } from "./AppImage.vue?vue&type=template&id=39e58976&scoped=true&"
import script from "./AppImage.vue?vue&type=script&lang=ts&"
export * from "./AppImage.vue?vue&type=script&lang=ts&"
import style0 from "./AppImage.vue?vue&type=style&index=0&id=39e58976&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e58976",
  null
  
)

export default component.exports